export const SUBSTANCE_OF_CONCERN = [
  'substance_of_concern',
  'substance_of_very_high_concern',
  'group_might_contain_substances_of_concern',
  'group_might_contain_substances_of_very_high_concern',
  'not_a_substance_of_concern',
  'unknown',
] as const;

// Reference doc: https://docs.google.com/spreadsheets/d/1wC8L7Oao2ybmHl-AurcQ0g0o7QbOnnxd65Okxag0k8Q/edit#gid=1597682651
// We only output a subset of these today.
export const SUBSTANCE_OF_CONCERN_HAZARD_CLASS = [
  'H220',
  'H360D',
  'H331',
  'H372',
  'H221',
  'H314',
  'H400',
  'H280',
  'H312',
  'H420',
  'H302',
  'H361',
  'H336',
  'H270',
  'H281',
  'H410',
  'H350',
  'H340',
  'H360FD',
  'H317',
  'H341',
  'H315',
  'H319',
  'H335',
  'H351',
  'H373',
  'H318',
  'H330',
  'H411',
] as const;

export const POLLUTANT_MEDIUM = [
  'air_emission',
  'water_emission',
  'soil_emission',
  'used',
  'procured',
  'leaves_in_product',
] as const;

export const SUBSTANCE_AND_MICROPLASTICS_INFLOW_MEDIUM = [
  'procured',
  'generated',
] as const;

export const SUBSTANCE_AND_MICROPLASTICS_INFLOW_MEDIUM_LABELS: Record<
  (typeof SUBSTANCE_AND_MICROPLASTICS_INFLOW_MEDIUM)[number],
  string
> = {
  procured: 'Procured',
  generated: 'Generated',
};

const SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_MEDIUM = [
  'leaves_as_product',
  'leaves_in_product',
] as const;

const SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_MEDIUM_LABELS: Record<
  (typeof SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_MEDIUM)[number],
  string
> = {
  leaves_as_product: 'Leaves as product',
  leaves_in_product: 'Leaves in product',
};

export const SUBSTANCE_OUTFLOW_MEDIUM = [
  ...SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_MEDIUM,
  'air_emission',
  'water_emission',
  'soil_emission',
] as const;

export const SUBSTANCE_OUTFLOW_MEDIUM_LABELS: Record<
  (typeof SUBSTANCE_OUTFLOW_MEDIUM)[number],
  string
> = {
  ...SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_MEDIUM_LABELS,
  air_emission: 'Air emission',
  water_emission: 'Water emission',
  soil_emission: 'Soil emission',
};

export const MICROPLASTICS_OUTFLOW_MEDIUM = [
  ...SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_MEDIUM,
  'emission',
] as const;

export const MICROPLASTICS_OUTFLOW_MEDIUM_LABELS: Record<
  (typeof MICROPLASTICS_OUTFLOW_MEDIUM)[number],
  string
> = {
  ...SUBSTANCE_AND_MICROPLASTICS_OUTFLOW_MEDIUM_LABELS,
  emission: 'Emission',
};

export const CAS_NUMBER_LABELS: Record<string, string> = {
  '7664-41-7': 'Ammonia (7664-41-7)',
  '71-43-2': 'Benzene (71-43-2)',
  '630-08-0': 'Carbon Monoxide (630-08-0)',
  '75-69-4': 'Trichlorofluoromethane (75-69-4)',
  '75-71-8': 'Dichlorodifluoromethane (75-71-8)',
  '75-72-9': 'Chlorotrifluoromethane (75-72-9)',
  '76-13-1': '1,1,2-trichloro-1,2,2-trifluoroethane (76-13-1)',
  '76-14-2': '1,2-dichloro-1,1,2,2-tetrafluoroethane (76-14-2)',
  '76-15-3': '1-chloro-1,1,2,2,2-pentafluoroethane (76-15-3)',
  '75-09-2': 'Dichloromethane (75-09-2)',
  '1511-62-2': 'Bromodifluoromethane (1511-62-2)',
  '1842-05-3': '1,1-dichloro-1,2-difluoroethane (1842-05-3)',
  '354-15-4': '1,1,2-trichloro-1,2-difluoroethane (354-15-4)',
  '354-23-4': '1,2-dichloro-1,1,2-trifluoroethane (354-23-4)',
  '75-61-6': 'Dibromodifluoromethane (75-61-6)',
  '353-59-3': 'Bromochlorodifluoromethane (353-59-3)',
  '354-33-6': '1,1,1,2,2-pentafluoroethane (354-33-6)',
  '406-58-6': '1,1,1,3,3-pentafluorobutane (406-58-6)',
  '420-46-2': '1,1,1-trifluoroethane (420-46-2)',
  '431-89-0': '1,1,1,2,3,3,3-heptafluoropropane (431-89-0)',
  '679-86-7': '1,1,2,2,3-pentafluoropropane (679-86-7)',
  '690-39-1': '1,1,1,3,3,3-hexafluoropropane (690-39-1)',
  '75-10-5': 'Difluoromethane (75-10-5)',
  '75-37-6': '1,1-difluoroethane (75-37-6)',
  '75-46-7': 'Trifluoromethane (75-46-7)',
  '811-97-2': '1,1,1,2-tetrafluoroethane (811-97-2)',
  '1717-00-6': '1,1-dichloro-1-fluoroethane (1717-00-6)',
  '2837-89-0': '2-chloro-1,1,1,2-tetrafluoroethane (2837-89-0)',
  '306-83-2': '2,2-dichloro-1,1,1-trifluoroethane (306-83-2)',
  '354-21-2': '1,2,2-trichloro-1,1-difluoroethane (354-21-2)',
  '359-28-4': '1,1,2-Trichloro-2-fluoroethane (359-28-4)',
  '422-56-0': '3,3-dichloro-1,1,1,2,2-pentafluoropropane (422-56-0)',
  '507-55-1': '1,3-dichloro-1,1,2,2,3-pentafluoropropane (507-55-1)',
  '75-43-4': 'Dichlorofluoromethane (75-43-4)',
  '75-45-6': 'Chlorodifluoromethane (75-45-6)',
  '75-68-3': '1-chloro-1,1-difluoroethane (75-68-3)',
  '102687-65-0': '(e)-1-chloro-3,3,3-trifluoroprop-1-ene (102687-65-0)',
  '106-97-8': 'Butane (106-97-8)',
  '109-66-0': 'Pentane (109-66-0)',
  '111512-60-8': '(Z)-1-Chloro-2,3,3,3-tetrafluoropropene (111512-60-8)',
  '115-07-1': 'Propene (115-07-1)',
  '1814-88-6': '1,1,1,2,2-pentafluoropropane (1814-88-6)',
  '2252-84-8': '1,1,1,2,2,3,3-heptafluoropropane (2252-84-8)',
  '24270-66-4': '1,1,2,3,3-pentafluoropropane (24270-66-4)',
  '29118-24-9': '(e)-1,3,3,3-tetrafluoroprop-1-ene (29118-24-9)',
  '29118-25-0': '(z)-1,3,3,3-tetrafluoroprop-1-ene (29118-25-0)',
  '353-36-6': 'Fluoroethane (353-36-6)',
  '360-89-4': 'Octafluoro-2-buene (360-89-4)',
  '375-17-7': '1,1,1,2,2,3,3,4,4-nonafluorobutane (375-17-7)',
  '420-45-1': '2,2-difluoropropane (420-45-1)',
  '421-07-8': '1,1,1-trifluoropropane (421-07-8)',
  '431-31-2': '1,1,1,2,3-pentafluoropropane (431-31-2)',
  '431-63-0': '1,1,1,2,3,3-hexafluoropropane (431-63-0)',
  '460-73-1': '1,1,1,3,3-pentafluoropropane (460-73-1)',
  '5528-43-8': '(z)-1,2,3,3,3-pentafluoroprop-1-ene (5528-43-8)',
  '5595-10-8': '1,2,3,3,3-Pentafluoroprop-1-ene (5595-10-8)',
  '677-21-4': '3,3,3-trifluoroprop-1-ene (677-21-4)',
  '677-56-5': '1,1,1,2,2,3-hexafluoropropane (677-56-5)',
  '692-49-9': '(z)-1,1,1,4,4,4-hexafluorobut-2-ene (692-49-9)',
  '74-84-0': 'Ethane (74-84-0)',
  '74-98-6': 'Propane (74-98-6)',
  '75-28-5': '2-Methylpropane (75-28-5)',
  '75-38-7': '1,1-difluoroethene (75-38-7)',
  '754-12-1': '2,3,3,3-tetrafluoroprop-1-ene (754-12-1)',
  '78-78-4': '2-Methylbutane (78-78-4)',
  '115-25-3': 'Octafluorocyclobutane (115-25-3)',
  '355-25-9': 'Decafluorobutane (355-25-9)',
  '75-73-0': 'Tetrafluoromethane (75-73-0)',
  '76-16-4': 'Hexafluoroethane (76-16-4)',
  '76-19-7': 'Octafluoropropane (76-19-7)',
  '56-23-5': 'Tetrachloromethane (56-23-5)',
  '67-66-3': 'Trichloromethane (67-66-3)',
  '7439-92-1': 'Lead (7439-92-1)',
};

// Reference doc: https://docs.google.com/spreadsheets/d/1wC8L7Oao2ybmHl-AurcQ0g0o7QbOnnxd65Okxag0k8Q/edit#gid=1451937436
// We only output a subset of these in our EM today.
export const EU_POLLUTANT_RELEASE_AND_TRANSFER_REGISTER_POLLUTANT_GROUPS = [
  'non_methane_volatile_organic_compounds',
  'particulate_matter',
  'polycyclic_aromatic_hydrocarbons',
  'sulfur_oxides',
  'hydrochlorofluorocarbons',
  'hydrofluorocarbons',
  'chlorofluorocarbons',
  'chlorides',
  'nitrogen_oxides',
  'copper_and_compounds',
  'lead_and_compounds',
  'chromium_and_compounds',
  'nickel_and_compounds',
  'cadmium_and_compounds',
  'arsenic_and_compounds',
  'mercury_and_compounds',
  'zinc_and_compounds',
] as const;

export const POLLUTANT_GROUP_LABELS: Record<
  (typeof EU_POLLUTANT_RELEASE_AND_TRANSFER_REGISTER_POLLUTANT_GROUPS)[number],
  string
> = {
  non_methane_volatile_organic_compounds:
    'Non methane volatile organic compounds',
  particulate_matter: 'Particulate matter',
  polycyclic_aromatic_hydrocarbons: 'Polycyclic aromatic hydrocarbons',
  sulfur_oxides: 'Sulfur oxides',
  hydrochlorofluorocarbons: 'Hydrochlorofluorocarbons ',
  hydrofluorocarbons: 'Hydrofluorocarbons ',
  chlorofluorocarbons: 'Chlorofluorocarbons',
  chlorides: 'Chlorides',
  nitrogen_oxides: 'Nitrogen oxides',
  copper_and_compounds: 'Copper and compounds',
  lead_and_compounds: 'Lead and compounds',
  chromium_and_compounds: 'Chromium and compounds',
  nickel_and_compounds: 'Nickel and compounds',
  cadmium_and_compounds: 'Cadmium and compounds',
  arsenic_and_compounds: 'Arsenic and compounds',
  mercury_and_compounds: 'Mercury and compounds',
  zinc_and_compounds: 'Zinc and compounds',
};

export const SUBSTANCE_OF_CONCERN_LABELS: Record<
  (typeof SUBSTANCE_OF_CONCERN)[number],
  string
> = {
  substance_of_concern: 'Substance of concern',
  not_a_substance_of_concern: 'Not a substance of concern',
  group_might_contain_substances_of_concern:
    'Group might contain substances of concern',
  group_might_contain_substances_of_very_high_concern:
    'Group might contain substances of very high concern',
  substance_of_very_high_concern: 'Substance of very high concern',
  unknown: 'Unknown',
};

// Reference doc: https://docs.google.com/spreadsheets/d/1wC8L7Oao2ybmHl-AurcQ0g0o7QbOnnxd65Okxag0k8Q/edit#gid=1597682651
// We only output a subset of these in our EM today.
export const CAS_NUMBER = [
  '630-08-0',
  '7664-41-7',
  '7439-92-1',
  '10024-97-2',
  '75-10-5',
  '354-33-6',
  '75-45-6',
  '67-66-3',
  '71-43-2',
] as const;

export const ENERGY_KIND_VALUES = ['cooling', 'electricity', 'heat', 'steam'];

export const HEATING_VALUE_KIND_VALUES = ['HHV', 'LHV'];
